<template>
  <div class="error-page">
    <!-- 背景ネットワーク装飾 -->
    <div class="error-page__background" aria-hidden="true">
      <img
        :src="require('@/assets/images/error/error_background.svg')"
        alt=""
        class="error-page__background-svg"
      />
    </div>

    <!-- コンテンツ -->
    <div class="error-page__content">
      <p class="error-page__status-code">404</p>
      <h1 class="error-page__title">お探しのページが見つかりません</h1>
      <p class="error-page__description">
        申し訳ございません。お探しのページは削除されたか、<br />
        URLが変更された可能性があります。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error404",
  mounted() {
    document.body.classList.add("error-page-active");
  },
  beforeDestroy() {
    document.body.classList.remove("error-page-active");
  },
};
</script>

<style lang="scss">
// Error404 表示中はレイアウト側の余白（router-view の padding、
// content-wrapper の min-height で残る下部余白）を相殺する。
body.error-page-active {
  .layout--main .router-view {
    padding: 0 !important;
  }
  .layout--main .content-wrapper {
    min-height: calc(var(--vh, 1vh) * 100) !important;
  }
}
</style>

<style scoped lang="scss">
.error-page {
  position: relative;
  min-height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  background-image: linear-gradient(
    180deg,
    oklch(97.91% 0.013 229.14) 0%,
    oklch(98.01% 0.017 210.42) 100%
  );
  display: flex;
  flex-direction: column;
}

.error-page__background {
  position: absolute;
  top: 5%;
  right: -7.95%;
  bottom: -51.39%;
  left: 11.75%;
  pointer-events: none;
}

.error-page__background-svg {
  width: 100%;
  height: 100%;
}

.error-page__content {
  position: relative;
  z-index: 10;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  text-align: center;
}

.error-page__status-code {
  margin: 0;
  display: inline-flex;
  align-items: center;
  height: 288px;
  font-family: "Sofia Sans Semi Condensed", sans-serif;
  font-size: 240px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 9.6px;
  background-image: linear-gradient(-34.57deg, #2d5089 14.65%, #4b83c4 64.14%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.error-page__title {
  margin: 1rem 0 0;
  font-size: 2.25rem;
  font-weight: 600;
  line-height: 120%;
  color: oklch(48.62% 0.041 260.28); // blue-gray-600
}

.error-page__description {
  margin-top: 1.25rem;
  max-width: 42rem;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 160%;
  color: oklch(55.44% 0.041 257.43); // blue-gray-500
}
</style>
